import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TranslationKey } from 'src/app/enums';

import { ApiService } from 'src/app/shared/api.service';
import { NotificationMessageType } from 'src/app/shared/enums';
import { IContactEmailCampaignSubscriptions } from 'src/app/shared/interfaces';
import { NotificationsService } from 'src/app/shared/notifications.service';

@Component({
    selector: 'aza-rws-profile-subscriptions',
    templateUrl: 'subscriptions.component.html',
    standalone: false
})
export class SubscriptionsComponent implements OnInit {
    @Output() closed = new EventEmitter<void>();

    loaded = false;
    subs: IContactEmailCampaignSubscriptions = { unsubscribe: false, subscriptions: [] };

    constructor(private apiSvc: ApiService, private notificationsSvc: NotificationsService, private translateSvc: TranslateService) {
    }

    ngOnInit(): void {
        this.loadData();
    }

    private async loadData(): Promise<void> {
        this.loaded = false;
        this.subs = { subscriptions: [], unsubscribe: false };
        this.subs = await this.apiSvc.getContactEmailCampaignSubscriptions();
        this.loaded = true;
    }

    async onSave(): Promise<void> {
        await this.apiSvc.setContactEmailCampaignSubscriptions(this.subs);
        this.notificationsSvc.showNotification(NotificationMessageType.success, this.translateSvc.instant(TranslationKey.saved));
    }

    onClosed(): void {
        this.closed.next();
    }
}
